import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import dateSort from 'scaleflow/utils/dateSort';
import type AgentModel from './agent';
import type InitiativeModel from './initiative';
import type MessageModel from './message';
import type PersonModel from './person';

export default class ConversationModel extends Model {
  declare [Type]: 'conversation';
  @attr('string') declare provider: string;
  @attr declare config: {
    url?: string;
    agent?: string | null;
    payload?: unknown;
  };
  @attr declare created_at: string;
  @attr declare updated_at: string;

  @belongsTo('initiative', {
    async: true,
    inverse: 'conversations',
  })
  declare initiative: AsyncBelongsTo<InitiativeModel>;

  @belongsTo('person', {
    async: true,
    inverse: 'conversations',
  })
  declare person: AsyncBelongsTo<PersonModel>;

  @attr('string') declare title: string;
  @attr('boolean', {
    defaultValue: false,
  })
  declare archived: boolean;

  @attr('string', {
    defaultValue: 'private',
  })
  declare visibility: 'public' | 'private';

  @hasMany('message', {
    async: true,
    inverse: 'conversation',
  })
  declare messages: AsyncHasMany<MessageModel>;

  @attr('boolean', { defaultValue: true }) declare complete: boolean;

  get sortedMessages(): MessageModel[] {
    return [...(this.messages.content ?? [])].sort((a, b) =>
      dateSort(a.created_at, b.created_at, 'asc'),
    );
  }

  setAgentOnConversation(agent: AgentModel) {
    this.config.url = agent.url;
    this.config.agent = agent.id;
    if (agent.config?.['payload'])
      this.config.payload = agent.config['payload'];
  }
}
